import type { BuildifyDocumentDefinition } from '@adornis/buildify/client/globals/types.js';
import { html } from 'lit';

export const CampusDocumentExtension: BuildifyDocumentDefinition = {
  render(content) {
    return html` <x-flex space="md"> ${content} </x-flex> `;
  },
};
